import axios from './index';

// 批次发货相关接口

// 商务确认
export const ConfirmBussiness = (params) =>
  axios.post(
    '/oms/confirm-bussiness',
    params
  );

// 驳回至供应接口
export const RejectSupply = (params) =>
  axios.post(
    '/oms/reject-to-supply',
    params
  );

// 查询办理详情
export const GetBatchDetails = (params) =>
  axios.post(
    '/oms/intel-batch-invoice-detail',
    params
  );

// 列表数据查询
export const GetBatchList = (params) =>
  axios.post(
    '/oms/query-batch-invoice-list',
    params
  );

// 导出批次发货单
export const ExportBatch = (params) =>
  axios.post(
    '/oms/expor-batch-shipment-detail',
    params,
    { responseType: 'blob' }
  );

// 导出发货单
export const ExportShipment = (params) =>
  axios.post(
    '/oms/expor-batch-partial-invoice',
    params,
    { responseType: 'blob' }
  );

// IntelPaymentBatchApplyController - 批次请款相关接口

// 分页查询待确认/已确认批次付款信息列表
export const GetIntelPaymentBatchApplyList = (params) =>
  axios.post(
    '/intelPaymentBatchApply/selectPaymentBatchList',
    params
  );

// 查看批次付款申请详情（主表+明细列表）
export const GetIntelPaymentBatchApplyDetail = (params) =>
  axios.get(
    `/intelPaymentBatchApply/getBatchPaymentDetail/${params.batchApplyId}`
  );
// 批次付款申请详情办理或驳回
export const IntelPaymentBatchApplyHandle = (params) =>
  axios.post(
    '/intelPaymentBatchApply/approval',
    params
  );
//   导出PI
export const ExportPI = (params) =>
  axios.post(
    '/intelPaymentBatchApply/exportPi',
    params,
    { responseType: 'blob', skipGlobalError: true }
  );
// 导出待确认/已确认批次付款列表
export const ExportIntelPaymentBatchApplyList = (params) =>
  axios.post(
    '/intelPaymentBatchApply/exportBatchPayment',
    params,
    { responseType: 'blob' }
  );
// 导出批次待确认付款明细
export const ExportIntelPaymentBatchApplyDetail = (params) =>
  axios.post(
    `/intelPaymentBatchApply/exportBatchPaymentDetail`,
    params,
    { responseType: 'blob' }
  );
export const ExportBatchPaymentDoneDetail = (params) =>
  axios.post(
    `/intelPaymentBatchApply/exportBatchPaymentDoneDetail`,
    params,
    { responseType: 'blob' }
  );

// 分页查询待确认/已确认批次付款详情页明细信息列表
export const GetIntelPaymentBatchApplyDetailList = (params) =>
  axios.post(
    '/intelPaymentBatchApply/selectPaymentBatchDetailList',
    params
  );
// 查询分配信息
export const GetAllocationInfo = (id) =>
  axios.get(
    '/oms/query-allocation-info', { params: { id } }
  );

// 产品详情分页查询
export const GetProductDetails = (params) =>
  axios.post(
    '/oms/query-product-list',
    params
  );

// 返利抵应收列表接口
export const GetRebateReceivableList = (params) =>
  axios.post(
    '/rebate-ar/business-approval/query',
    params
  );

// 返利抵应收详情接口
export const GetRebateReceivableDetail = (applicationNo) =>
  axios.get(
    `/rebate-ar/business-approval/${applicationNo}`
  );

// 返利抵应收审批接口
export const ApproveRebateReceivable = (params) =>
  axios.post(
    '/rebate-ar/business-approval/process',
    params
  );

// 返利抵应收附件下载接口（附件下载单独走渠道网关服务地址）
export const fileDownload = (id) =>
  axios.get(
    `/partners-common-service/file/download/${id}`,
    {
      responseType: 'blob',
      baseURL: window._env_.CREDITCONTROL_APIBASE_URL
    }
  );
